import sanitizeHTML from '@pinecast/common/helpers/sanitize';
import {fromMarkdown} from 'mdast-util-from-markdown';
import {toHast} from 'mdast-util-to-hast';
import {toHtml} from 'hast-util-to-html';

// const processor = remark().use(remarkHtml, {allowDangerousHtml: true});

export function markdownToHTML(markdown: string): string {
  const mdast = fromMarkdown(markdown);
  const hast = toHast(mdast, {allowDangerousHtml: true});
  const rawHTML = toHtml(hast, {allowDangerousHtml: true});

  const html = sanitizeHTML(rawHTML, {
    allowedTags: [
      'A',
      'B',
      'BR',
      'EM',
      'H1',
      'H2',
      'H3',
      'HR',
      'I',
      'LI',
      'OL',
      'P',
      'SPAN',
      'STRONG',
      'UL',
    ],
  });

  return html;
}
